<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :show-add-button="false"
        :show-default-action-buttons="false"
        scrollable="paymentSettings"
        title="Payment Settings"
        icon="mdi-card-bulleted-settings-outline"
        stateendpoint="paymentSetting.paymentSettings"
        sort="ordering"
        :actions="actions"
        :disable-default-footer="true"
        :disable-pagination="true"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";

export default {
  name: 'PaymentSettings',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Payment Settings | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage},
  data() {
    return {
      headers: [
        {
          text: 'Sort',
          value: 'ordering'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Status',
          value: 'status'
        }
      ],
      columns: [
        {value: 'name'},
        {value: 'isActive'}
      ],
      actions: {
        load: 'loadPaymentSettings',
        update: 'updatePaymentSettings',
        sorted: 'sortedPaymentSettings',
      }
    }
  }
}
</script>
